import { render, staticRenderFns } from "./guardPayment.vue?vue&type=template&id=0d54690a&scoped=true&"
import script from "./guardPayment.vue?vue&type=script&lang=js&"
export * from "./guardPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d54690a",
  null
  
)

export default component.exports